// eslint-disable-next-line import/prefer-default-export
export function downloadFile(content, type, filename) {
  const byteNumbers = new Array(content.length);
  for (let i = 0; i < content.length; i += 1) {
    byteNumbers[i] = content.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type });
  const URL = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = URL;
  a.download = filename;
  document.body.append(a);
  a.click();
}
